import React, { useState } from "react";
import TitleStripe from "../../common/TitleStripe";
import { Alert } from "flowbite-react";
import NoOcurrence from "../../common/query/NoOcurrence";

const VeiculosPorDocumento = ({ data }) => {
  return (
    <div>
      {data?.veiculosPorDocumento?.statusRetorno == 1 ? (
        <div>
          <TitleStripe>Veiculos Por Documento</TitleStripe>
          {data?.veiculosPorDocumento?.veiculos?.length > 0 ? (
            <div className="flex flex-col gap-3 mt-4">
              {data?.veiculosPorDocumento?.veiculos?.map((veiculo, index) => (
                <div
                  key={index}
                  className="border border-gray-400 rounded-md overflow-hidden"
                >
                  <div className="bg-gray-200 px-2 py-1 text-green-600 font-semibold">
                    {veiculo?.marcaModelo || "Sem info."}
                  </div>
                  <div className="grid grid-cols-3 gap-2 p-2">
                    <div className="flex flex-col">
                      <div className="font-semibold">Placa:</div>
                      <div>{veiculo?.placa || "Sem info."}</div>
                    </div>
                    <div className="flex flex-col">
                      <div className="font-semibold">Chassi:</div>
                      <div>{veiculo?.chassi || "Sem info."}</div>
                    </div>
                    <div className="flex flex-col">
                      <div className="font-semibold">Renavam:</div>
                      <div>{veiculo?.renavam || "Sem info."}</div>
                    </div>
                    <div className="flex flex-col">
                      <div className="font-semibold">Cor:</div>
                      <div>{veiculo?.corVeiculo || "Sem info."}</div>
                    </div>
                    <div className="flex flex-col">
                      <div className="font-semibold">Combustível:</div>
                      <div>{veiculo?.combustivel || "Sem info."}</div>
                    </div>
                    <div className="flex flex-col">
                      <div className="font-semibold">Situação:</div>
                      <div>{veiculo?.situacao || "Sem info."}</div>
                    </div>
                    <div className="flex flex-col">
                      <div className="font-semibold">Potência:</div>
                      <div>{veiculo?.potenciaVeiculo || "Sem info."}</div>
                    </div>
                    <div className="flex flex-col">
                      <div className="font-semibold">Ano Modelo:</div>
                      <div>{veiculo?.anoModelo || "Sem info."}</div>
                    </div>
                    <div className="flex flex-col">
                      <div className="font-semibold">Ano Fabr.:</div>
                      <div>{veiculo?.anoFabricacao || "Sem info."}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <NoOcurrence className="mt-4" />
          )}
        </div>
      ) : (
        <div>
          <TitleStripe>Veiculos Por Documento</TitleStripe>
          <Alert withBorderAccent color="gray" className="mt-5">
            Consulta Indisponível no momento
          </Alert>
        </div>
      )}
    </div>
  );
};

export default VeiculosPorDocumento;
